type Props = {
  width?: string;
  height?: string;
  strokeColor?: string;
  /**
   * The struck line's colour. Defaults to the redlines view's own removed-word
   * red, so the glyph previews what the view shows; pass `strokeColor` for a
   * monochrome glyph (a pressed or inert state).
   */
  strikeColor?: string;
};

/**
 * PLAT-11877 — the Redlines view: three text lines with the middle one barred
 * edge to edge in the redlines' red. No page frame, so at 14px it reads as a
 * different shape from the Clip Text page (`TranscriptIcon`) beside it. It
 * shows edits; it does not make them, which is what the pencil it replaced
 * said. See "Icon Semantics" in docs/design-system.md.
 */
const RedlinesIcon = (props: Props) => {
  const {
    width = '14',
    height = '14',
    strokeColor = 'currentColor',
    strikeColor = 'indianred',
  } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="4" y1="6" x2="20" y2="6" />
      <line x1="4" y1="12" x2="14" y2="12" />
      <line
        x1="2"
        y1="12"
        x2="22"
        y2="12"
        stroke={strikeColor}
        strokeWidth="3"
      />
      <line x1="4" y1="18" x2="18" y2="18" />
    </svg>
  );
};

export default RedlinesIcon;
